import { createFileRoute, redirect } from '@tanstack/react-router';

/** Compat: URL antiga → /admin/usuarios */
export const Route = createFileRoute('/_authenticated/usuarios/')({
  beforeLoad: () => redirect({ to: '/admin/usuarios' }),
});
